module.exports = __webpack_public_path__ + "static/me-eba4b69030d215a87455a6191f19f963.jpg";